import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "md:flex gap-2 md:gap-4 mt-4 md:mt-6" }
const _hoisted_2 = { class: "md:space-y-4 space-y-2 mx-auto" }
const _hoisted_3 = { class: "bg-gray-700 rounded-md animate-pulse h-72 w-56 m-auto md:m-0" }
const _hoisted_4 = { class: "relative left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" }
const _hoisted_5 = { class: "rounded-md p-2 md:p-4 w-full bg-[#222222] text-white space-y-2 md:space-y-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "animate-pulse w-16 h-5 bg-gray-700 rounded-lg" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "animate-pulse w-16 h-5 bg-gray-700 rounded-lg" }, null, -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "space-y-2 md:space-y-4 w-full" }
const _hoisted_10 = { class: "rounded-md p-2 md:p-4 w-full h-fit bg-[#222222] text-white text-start overflow-hidden space-y-2 md:space-y-4 md:mt-0 mt-2" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center justify-between gap-2 md:gap-4\"><div class=\"animate-pulse w-1/4 h-8 bg-gray-700 rounded-lg\"></div><div class=\"flex gap-2 md:gap-4\"><div class=\"animate-pulse w-8 h-8 bg-gray-700 rounded-lg\"></div><div class=\"animate-pulse w-8 h-8 bg-gray-700 rounded-lg hidden md:block\"></div><div class=\"animate-pulse w-8 h-8 bg-gray-700 rounded-lg hidden md:block\"></div></div></div>", 1)
const _hoisted_12 = { class: "flex flex-wrap gap-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "animate-pulse w-full h-20 bg-gray-700 rounded-lg" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "animate-pulse w-full h-28 bg-gray-700 rounded-lg" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-end gap-2 md:gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "animate-pulse w-16 h-8 bg-gray-700 rounded-lg" }),
  /*#__PURE__*/_createElementVNode("div", { class: "animate-pulse w-20 h-8 bg-gray-700 rounded-lg" })
], -1)
const _hoisted_16 = { class: "rounded-md p-2 md:p-4 w-full h-fit bg-[#222222] text-white text-start overflow-hidden space-y-2 md:space-y-4 md:mt-0 mt-2" }
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center justify-between\"><div class=\"animate-pulse w-1/4 h-8 bg-gray-700 rounded-lg\"></div><div class=\"hidden md:flex gap-2 md:gap-4\"><div class=\"animate-pulse w-8 h-8 bg-gray-700 rounded-lg\"></div><div class=\"animate-pulse w-8 h-8 bg-gray-700 rounded-lg\"></div></div></div>", 1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "flex gap-2 md:gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "animate-pulse w-full h-20 bg-gray-700 rounded-lg" }),
  /*#__PURE__*/_createElementVNode("div", { class: "animate-pulse w-full h-20 bg-gray-700 rounded-lg" })
], -1)
const _hoisted_19 = { class: "grid grid-cols-[repeat(auto-fill,_minmax(10rem,_1fr))] gap-2 md:gap-4" }
const _hoisted_20 = { class: "md:space-y-4 space-y-2 mx-auto" }
const _hoisted_21 = { class: "relative w-fit m-auto" }
const _hoisted_22 = { class: "h-72" }
const _hoisted_23 = {
  key: 0,
  class: "rounded-full p-1 bg-black text-yellow-400 w-6 h-6 absolute right-1 top-1"
}
const _hoisted_24 = { class: "rounded-md p-2 md:p-4 w-full bg-[#222222] text-white space-y-2 md:space-y-4" }
const _hoisted_25 = { class: "flex justify-between items-center space-x-2 md:space-x-4 h-5" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "Studio", -1)
const _hoisted_27 = { class: "text-ellipsis whitespace-nowrap overflow-hidden" }
const _hoisted_28 = { class: "flex justify-between items-center space-x-2 md:space-x-4 h-5" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "Status", -1)
const _hoisted_30 = { class: "text-ellipsis whitespace-nowrap overflow-hidden" }
const _hoisted_31 = {
  key: 0,
  class: "flex justify-between items-center space-x-2 md:space-x-4 h-5"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "Published", -1)
const _hoisted_33 = { class: "text-ellipsis whitespace-nowrap overflow-hidden" }
const _hoisted_34 = {
  key: 1,
  class: "flex justify-between items-center space-x-2 md:space-x-4 h-5"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "Updated", -1)
const _hoisted_36 = { class: "text-ellipsis whitespace-nowrap overflow-hidden" }
const _hoisted_37 = { class: "space-y-2 md:space-y-4 w-full" }
const _hoisted_38 = { class: "rounded-md p-2 md:p-4 w-full h-fit bg-[#222222] text-white text-start overflow-hidden space-y-2 md:space-y-4 md:mt-0 mt-2" }
const _hoisted_39 = { class: "flex justify-between gap-2 md:gap-4" }
const _hoisted_40 = { class: "text-lg font-bold" }
const _hoisted_41 = { class: "flex gap-2 md:gap-4" }
const _hoisted_42 = { class: "flex flex-wrap gap-2" }
const _hoisted_43 = ["innerHTML"]
const _hoisted_44 = { class: "flex justify-end gap-2 md:gap-4" }
const _hoisted_45 = { class: "rounded-md p-2 md:p-4 w-full h-fit bg-[#222222] text-white text-start overflow-hidden space-y-2 md:space-y-4 md:mt-0 mt-2" }
const _hoisted_46 = { class: "flex items-center justify-between" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-lg" }, "Episode", -1)
const _hoisted_48 = { class: "hidden md:flex items-center gap-2 md:gap-4" }
const _hoisted_49 = {
  key: 0,
  class: "flex gap-2 md:gap-4"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", null, "Read First Episode", -1)
const _hoisted_51 = { class: "text-lg" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", null, "Read Last Episode", -1)
const _hoisted_53 = { class: "text-lg" }
const _hoisted_54 = { class: "grid grid-cols-[repeat(auto-fill,_minmax(10rem,_1fr))] gap-2 md:gap-4" }
const _hoisted_55 = { class: "font-bold" }
const _hoisted_56 = { class: "text-gray-400" }

import { Button, Divider, Modal, Textarea } from 'ant-design-vue';
import { HttpStatusCode } from 'axios';
import { capitalize, createVNode, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import {
	DeleteFilled,
	DeleteOutlined,
	EditOutlined,
	PlusOutlined,
	StarFilled,
	StarOutlined
} from '@ant-design/icons-vue';
import AddEpisode from '@/components/disposable/AddEpisode.vue';
import ImageLoading from '@/components/shared/ImageLoading.vue';
import LocationLink from '@/components/shared/LocationLink.vue';
import { Hentai } from '@/model/hentai';
import {
	getHentai,
	deleteHentai,
	updateNoteHentai,
	deleteHentaiEpisode,
	favoriteHentai
} from '@/repository/hentai';


export default /*#__PURE__*/_defineComponent({
  __name: 'HentaiDetailView',
  setup(__props) {

const { push } = useRouter();
const hentaiUUID = useRoute().params.hentaiUUID as string;
const store = useStore();

const isFetching = ref(true);
const isLoading = ref(true);
const hentai = ref<Hentai>();
const episodes = ref<string[]>([]);
const openedModal = ref(false);
const isDelete = ref(false);
const isLoadingImage = ref(true);

onMounted(async () => fetchData());

const link = (episode: string) => hentai.value?.episode[episode].link || '';

async function fetchData() {
	isLoading.value = true;
	try {
		const res = await getHentai(hentaiUUID);
		if (!res || res.status !== HttpStatusCode.Ok || !res.data) {
			throw Error('hentai uuid is not found');
		}
		hentai.value = res.data;
		episodes.value =
			Object.keys(hentai.value.episode || {}).sort((a, b) => Number(a) - Number(b)) || [];
		document.title = `${res.data.title} - Hentai | Unikume Kinkando`;
	} catch (error) {
		store.dispatch('alert', {
			type: 'error',
			message: `${error}` || 'something went wrong, please try again!'
		});
		push(`/hentai`);
	} finally {
		isLoading.value = false;
		isFetching.value = false;
	}
}

async function updateNote() {
	if (!hentai.value) {
		return;
	}
	try {
		isLoading.value = true;
		await updateNoteHentai(hentaiUUID, hentai.value.note);
		store.dispatch('alert', { type: 'success', message: 'Update note successfully!' });
	} catch (error) {
		store.dispatch('alert', {
			type: 'error',
			message: `${error}` || 'something went wrong, please try again!'
		});
	} finally {
		isLoading.value = false;
	}
}

async function favorite() {
	if (!hentai.value) {
		return;
	}
	hentai.value.isFavorite = !hentai.value.isFavorite;
	await favoriteHentai(hentaiUUID, hentai.value.isFavorite);
}

async function deleteHentaiData() {
	Modal.confirm({
		title: `Delete Hentai`,
		icon: createVNode(DeleteFilled),
		content: `Do you want to delete hentai '${hentai.value?.title}' right?`,
		okText: 'Yes',
		cancelText: 'No',
		async onOk() {
			await deleteHentai(hentai.value?.hentaiUUID ?? '');
			await push(`/hentai`);
			store.dispatch('alert', {
				type: 'success',
				message: `delete hentai ${hentai.value?.title} successfully!`
			});
		}
	});
}

function dateTime(date: Date) {
	return new Date(date).toLocaleString('en-US', {
		year: 'numeric',
		month: 'short',
		day: '2-digit'
	});
}

async function deleteEpisode(episode: string) {
	if (!hentai.value || !isDelete.value) {
		return;
	}
	Modal.confirm({
		title: `Delete Episode ${episode}`,
		icon: createVNode(DeleteOutlined),
		content: `Do you want to delete ${hentai.value.title} episode ${episode}?`,
		okText: 'Yes',
		cancelText: 'No',
		async onOk() {
			await deleteHentaiEpisode(hentai.value?.hentaiUUID ?? '', episode);
			await fetchData();
			await store.dispatch('alert', {
				type: 'success',
				message: `Delete episode ${episode} successfully!`
			});
		}
	});
}

return (_ctx: any,_cache: any) => {
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AddEpisode, {
      hentaiUUID: _unref(hentaiUUID),
      isOpened: openedModal.value,
      onClose: () => (openedModal.value = false),
      onOnBeforeClose: fetchData
    }, null, 8, ["hentaiUUID", "isOpened", "onClose"]),
    _createElementVNode("div", _hoisted_1, [
      (isFetching.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_a_spin, {
                    tip: "Loading...",
                    size: "large",
                    class: "animate-pulse"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array(4), (_, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "flex justify-between items-center space-x-2 md:space-x-4"
                  }, _hoisted_8))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array(3), (_, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "rounded-lg bg-gray-700 w-16 h-7"
                    }))
                  }), 128))
                ]),
                _createVNode(_unref(Divider), { class: "bg-gray-600" }),
                _hoisted_13,
                _createVNode(_unref(Divider), { class: "bg-gray-600" }),
                _hoisted_14,
                _hoisted_15
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createVNode(_unref(Divider), { class: "bg-gray-600" }),
                _hoisted_18,
                _createVNode(_unref(Divider), { class: "bg-gray-600" }),
                _createElementVNode("div", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array(10), (_, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "h-16 min-w-[9rem] w-full bg-gray-700 rounded-lg"
                    }))
                  }), 128))
                ])
              ])
            ])
          ], 64))
        : (hentai.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(ImageLoading, {
                      previewable: "",
                      src: hentai.value.coverImageURL,
                      "img-class": "!h-72 !w-56",
                      "loading-class": "h-72 w-56 m-auto md:m-0",
                      onLoad: _cache[0] || (_cache[0] = () => (isLoadingImage.value = false))
                    }, null, 8, ["src"])
                  ]),
                  (hentai.value.isFavorite && !isLoading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createVNode(_unref(StarFilled))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createElementVNode("div", _hoisted_27, _toDisplayString(capitalize(hentai.value.studio)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("div", _hoisted_30, _toDisplayString(capitalize(hentai.value.status)), 1)
                  ]),
                  (hentai.value.createdAt)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _hoisted_32,
                        _createElementVNode("div", _hoisted_33, _toDisplayString(dateTime(hentai.value.createdAt)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (hentai.value.updatedAt)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _hoisted_35,
                        _createElementVNode("div", _hoisted_36, _toDisplayString(dateTime(hentai.value.updatedAt)), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, _toDisplayString(hentai.value.title), 1),
                    _createElementVNode("div", _hoisted_41, [
                      _createVNode(_unref(Button), {
                        type: "primary",
                        onClick: favorite,
                        class: "bg-yellow-400 hover:!bg-yellow-500 text-orange-600 hover:!text-orange-600"
                      }, {
                        icon: _withCtx(() => [
                          (hentai.value.isFavorite)
                            ? (_openBlock(), _createBlock(_unref(StarFilled), { key: 0 }))
                            : (_openBlock(), _createBlock(_unref(StarOutlined), { key: 1 }))
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Button), {
                        type: "primary",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(push)(`/hentai/update/${hentai.value.hentaiUUID}`))),
                        class: "hidden md:block"
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(EditOutlined))
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Button), {
                        danger: "",
                        type: "primary",
                        onClick: deleteHentaiData,
                        class: "hidden md:block"
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(DeleteOutlined))
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hentai.value.categories, (category, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "rounded-md px-2 py-1 bg-[#343434] h-7"
                      }, _toDisplayString(category), 1))
                    }), 128))
                  ]),
                  _createVNode(_unref(Divider), { class: "bg-gray-600" }),
                  _createElementVNode("div", {
                    innerHTML: hentai.value.description
                  }, null, 8, _hoisted_43),
                  _createVNode(_unref(Divider), { class: "bg-gray-600" }),
                  _createVNode(_unref(Textarea), {
                    value: hentai.value.note,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((hentai.value.note) = $event)),
                    placeholder: `Enter a note`,
                    autoSize: "",
                    class: "bg-gray-600 text-white border-black placeholder:text-gray-400 !min-h-[116px]"
                  }, null, 8, ["value"]),
                  _createElementVNode("div", _hoisted_44, [
                    _createVNode(_unref(Button), {
                      "html-type": "reset",
                      onClick: fetchData
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Reset")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Button), {
                      "html-type": "submit",
                      type: "primary",
                      class: "disabled",
                      onClick: updateNote
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Update")
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _hoisted_47,
                    _createElementVNode("div", _hoisted_48, [
                      _createVNode(_unref(Button), {
                        type: "primary",
                        class: "bg-[#5cb85c] hover:!bg-[#518351]",
                        onClick: _cache[3] || (_cache[3] = () => (openedModal.value = true))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(PlusOutlined))
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Button), {
                        type: isDelete.value ? 'primary' : 'default',
                        danger: "",
                        onClick: _cache[4] || (_cache[4] = () => (isDelete.value = !isDelete.value))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(DeleteOutlined))
                        ]),
                        _: 1
                      }, 8, ["type"])
                    ])
                  ]),
                  _createVNode(_unref(Divider), { class: "bg-gray-600" }),
                  (episodes.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                        _createVNode(LocationLink, {
                          to: isDelete.value ? `` : link(episodes.value[0]),
                          isExternalLink: "",
                          class: "w-full"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Button), { class: "rounded-md h-20 w-full" }, {
                              default: _withCtx(() => [
                                _hoisted_50,
                                _createElementVNode("div", _hoisted_51, "Episode " + _toDisplayString(episodes.value[0]), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["to"]),
                        _createVNode(LocationLink, {
                          to: isDelete.value ? `` : link(episodes.value[episodes.value.length - 1]),
                          isExternalLink: "",
                          class: "w-full"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Button), { class: "rounded-md h-20 w-full" }, {
                              default: _withCtx(() => [
                                _hoisted_52,
                                _createElementVNode("div", _hoisted_53, "Episode " + _toDisplayString(episodes.value[episodes.value.length - 1]), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]))
                    : _createCommentVNode("", true),
                  (episodes.value.length > 0)
                    ? (_openBlock(), _createBlock(_unref(Divider), {
                        key: 1,
                        class: "bg-gray-600"
                      }))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_54, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(episodes.value, (episode, index) => {
                      return (_openBlock(), _createBlock(LocationLink, {
                        key: index,
                        to: isDelete.value ? `` : link(episode),
                        isExternalLink: !isDelete.value
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Button), {
                            class: "text-start h-16 min-w-[9rem] w-full",
                            onClick: () => deleteEpisode(episode)
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_55, "Episode " + _toDisplayString(episode), 1),
                              _createElementVNode("div", _hoisted_56, _toDisplayString(dateTime(hentai.value.episode[episode].createdAt!)), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1032, ["to", "isExternalLink"]))
                    }), 128))
                  ])
                ])
              ])
            ], 64))
          : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})